import { Popover } from 'bootstrap';

export function initFootnotes(
    noteSelector = '.chapter-main-content a[href^="#nota-"]'
){

    // Encontra todos as referências (links cujo href começa com "#nota-") que serão os gatilhos para os popovers de notas
    let noteReferencesList = [].slice.call(document.querySelectorAll(noteSelector));

    // Se pelo menos uma referência é encontrada,
    if (noteReferencesList.length > 0) {

        //tenta configurar o popover de cada referência
        noteReferencesList.map(function (ref, index) {

            // Salva valor do atributo href da referência
            let noteId = ref.getAttribute('href'),
                noteElement;


            // tenta encontrar elemento na página com valor salvo como seletor
            try {
                noteElement = document.querySelector(noteId);
            }
            catch(error) {
                console.log(error)
            }

            // se elemento é encontrado, inicializa popup
            if (noteElement !== undefined && noteElement !== null) {

                // adiciona atributos à referência, necessários para o funcionamento do popover
                ref.setAttribute('data-bs-toggle', 'popover');
                ref.setAttribute('tab-index', index);
                ref.setAttribute('role', 'button');
                ref.setAttribute('placement', 'bottom');

                // remove comportamento padrão da tag <a> ao ser clicada
                ref.addEventListener('click', function(e) {
                    e.preventDefault();
                });

                // instancia objeto da classe Popover do bootstrap
                let popoverObject = new Popover(ref, {
                    container: '#pageMainContent',
                    html: true,
                    content: noteElement,
                    trigger: 'focus',
                    placement: 'bottom',
                    template: '<div class="popover note-popover shadow-lg" role="tooltip"><div class="popover-arrow note-popover__arrow"></div><div class="popover-body note-popover__content"></div></div>',
                });

                // remove comportamento padrão de fechar popover quando o popover é clicado
                noteElement.addEventListener('mousedown', function () {
                    // e.preventDefault();
                });
                noteElement.addEventListener('touchstart', function () {
                    // e.preventDefault();
                });

                // caso a função .map esteja sendo utilizada como valor de uma variável (para ser manipulado posteriormente), o comando a seguir faz com que função retorne o objeto do popover
                // return popoverObject;

            } else {
                console.log(`não foram encontradas notas com o seletor "${noteId}"`);
            }

        })

    }

}



// WEBPACK FOOTER //
// ./scripts/components/footnotes.js